import {InquiryMultiField} from "./inquiry_multi_field";

export const PersonNameFieldConfig = {
    baseHtmlClass: 'inquiry_field--person_name',
    selector: '.inquiry_field--person_name',

    nameInputNameAttribute: 'person[name]'
}

export class PersonNameField extends InquiryMultiField {

    static new(InquiryForm) {
        if (!InquiryForm.element) { return null }
        const element = InquiryForm.element.querySelector(PersonNameFieldConfig.selector);
        if (element) { return new PersonNameField(element, InquiryForm) }
    }

    constructor(id_or_element, InquiryForm) {
        super(id_or_element, InquiryForm);
    }



    // The one name input (the person's whole name, split by the server)…

    getNameInput() {
        let nameInput = null;
        this.inputElements.forEach( (input) => {
            if (input.getAttribute('name') === PersonNameFieldConfig.nameInputNameAttribute) { nameInput = input }
        });
        return nameInput;
    }

    getNameInputValue() {
        const input = this.getNameInput();
        const value = input ? input.value.trim() : null;
        return this.typecastValue(value);
    }



    // Returns the single value as calculated by looking at each of the inputs.
    getInputsValue() {
        let value = this.getInputsValues().join(' ').trim();
        return (value);
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = String(value);
        return value;
    }

    hasValue() {
        return this.value !== null && this.value !== '';
    }

    beforeUpdate() {
        this.errorChecking = true;
        // if (this.InquiryForm.hasCurrentPerson()) { this.errorChecking = false } // No error checking when we have a current person.
        // if (!this.InquiryForm.hasCommittedMinimumRequirements()) { this.errorChecking = false } // No error checking until user has committed the minimum requirements.
        super.beforeUpdate();
    }

    // Only a rendered input is required. A signed-in person who already has a name is shown no
    // name input, and their stored name already satisfies the server. Any non-blank name will do.
    appendErrors() {
        if (this.getNameInput() && !this.getNameInputValue()) { this.errors.push(`${ this.label } must include your name.`) }
    }

}